import type { ReactNode } from 'react';

import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { Box, Button, Typography } from '@mui/material';

/** Monospace inline code text (card numbers, codes, references) per the design system. */
export function CodeText({ children }: { children: ReactNode }) {
  return (
    <Typography component="span" variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
      {children}
    </Typography>
  );
}

interface SectionHeaderProps {
  title: string;
  onAdd?: () => void;
  addLabel?: string;
}

/** A bordered section header with an optional "Add" action (shown only when permitted). */
export function SectionHeader({ title, onAdd, addLabel }: SectionHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        px: 2.5,
        py: 1.5,
        borderBottom: (t) => `1px solid ${t.palette.divider}`,
      }}
    >
      <Typography variant="h6">{title}</Typography>
      {onAdd ? (
        <Button size="small" startIcon={<AddRoundedIcon />} onClick={onAdd}>
          {addLabel ?? 'Добавить'}
        </Button>
      ) : null}
    </Box>
  );
}
